$(function () {
    // vyhladavanie podla definovaneho searchtype
    var catalogSearchForm = $('#catalogSearchForm');
    catalogSearchForm.submit(function (event, data) {

        //check if anything is even submitted
        const checkedCheckboxes = document.querySelectorAll('#catalogSearchForm input[type="checkbox"]:checked');
        let brand = document.getElementById("catalogSearchFormBrand");
        let priceRange = $('#priceRange');
        let ageRange = $('#ageRange');

        if(brand){
            brand = brand.value;
        } else {
            brand = "";
        }
        if(priceRange.data('start') == document.getElementById('minPrice').value &&
            priceRange.data('end') == document.getElementById('maxPrice').value &&
            ageRange.data('start') == document.getElementById('minAge').value &&
            ageRange.data('end') == document.getElementById('maxAge').value &&
            checkedCheckboxes.length == 0 && brand == ""
        ){
            event.preventDefault(); // Prevent the default form submission
            window.location.href = document.getElementById('baseUrl').value;
            return false;
        }
        if (data && data.submit) {
            return true;
        } else {
            var self = $(this);

            // zrusime query text
            catalogSearchForm.find('input.topSearchText').val('');

            // zobrazime loading
            $('#search-panel').loading();

            // postneme form
            window.setTimeout(function () {
                self.trigger('submit', {submit:true});
            }, 100);

            return false;
        }
    });
    // nastavit selecty a checkboxy
    catalogSearchForm.find('select').change(function () {
        catalogSearchForm.submit();
    });
    catalogSearchForm.find('input[type=checkbox]').click(function () {
        catalogSearchForm.submit();
    });

    //vyhladavanie podla definovaneho searchtype
    var catalogSideSearchForm = $('#catalogSideSearchForm');
    var catalogSideSearchProgress = $('#catalogSideSearchProgress');
    $('#catalogSideSearchForm').submit(function (event, data) {

        //check if anything is even submitted
        const checkedCheckboxes = document.querySelectorAll('#catalogSideSearchForm input[type="checkbox"]:checked');
        let brand = document.getElementById("catalogSearchFormBrand");
        let priceRange = $('#priceRange');
        let ageRange = $('#ageRange');

        if(brand){
            brand = brand.value;
        } else {
            brand = "";
        }
        if(priceRange.data('start') == document.getElementById('minPrice').value &&
            priceRange.data('end') == document.getElementById('maxPrice').value &&
            ageRange.data('start') == document.getElementById('minAge').value &&
            ageRange.data('end') == document.getElementById('maxAge').value &&
            checkedCheckboxes.length == 0 && brand == ""
        ){
            event.preventDefault(); // Prevent the default form submission
            window.location.href = document.getElementById('baseUrl').value;
            return false;
        }

        if (data && data.submit) {
            return true;
        } else {
            var self = $(this);
            catalogSideSearchProgress.height(catalogSideSearchForm.height());
            catalogSideSearchProgress.fadeTo('fast', 0.8);
            window.setTimeout(function () {
                self.trigger('submit', {submit:true});
            }, 500);
            return false;
        }
    });

    //nastavit selecty a checkboxy
    catalogSideSearchForm.find('select').change(function () {
        catalogSideSearchForm.submit();
    });
    catalogSideSearchForm.find('input[type=checkbox]').click(function () {
        catalogSideSearchForm.submit();
    });

    //viac / menej poloziek vo filtry
    $('div.more a', catalogSideSearchForm).click(function () {
        var a = $(this);
        var wrapper = a.parents('div.content').find('div.item-wrapper');
        if (!wrapper.length) {
            //vytvorime wrapper, ktory budeme schovavat a zobrazovat
            var items = a.parents('div.content').find('div.item');
            var visible = items.filter(':visible').length;
            var itemsToDisplay = items.slice(visible);
            itemsToDisplay.wrapAll('<div class="item-wrapper"></div>');
            wrapper = itemsToDisplay.closest('div.item-wrapper');
            wrapper.hide();
            itemsToDisplay.show();
            wrapper.after(a.closest('div.more'));
        }
        //zobrazime/skryjeme wrapper
        wrapper.slideToggle();
        //vymenime text v zobrazovaci
        var alttext = a.data('alttext');
        a.data('alttext', a.text());
        a.text(alttext);
    });

    // rovnaka výška kategorii v riadku
    $('ul.subcategoryMenu li.firstInRow').each(function (rowidx, rowelem) {
        var row = $(rowelem);
        var boxHeight = row.outerHeight();
        var items = row.nextUntil('li.firstInRow');
        items.each(function (idx, elem) {
            var item = $(elem);
            if (boxHeight < item.outerHeight()){
                boxHeight = item.outerHeight();
            }
        });
        items.css('height', boxHeight);
        row.css('height', boxHeight);
    });

    /* Price range */
    let priceRange = $('#priceRange');
    if (priceRange.length) {
        let useDecimal = priceRange.data('currency') === 'EUR';
        noUiSlider.create(priceRange[0], {
            start: [priceRange.data('start'), priceRange.data('end')],
            connect: true,
            step: useDecimal ? 0.1 : 0,
            range: {
                'min': priceRange.data('min'),
                'max': priceRange.data('max')
            },
            format: {
                to: function(value) {
                    if (useDecimal) {
                        return parseFloat(value).toFixed(1);
                    }
                    return Math.round(value);
                },
                from: function (value) {
                    if (useDecimal) {
                        return parseFloat(value).toFixed(1);
                    }
                    return Math.round(value);
                }
            }
        });

        let minPrice = document.getElementById('minPrice');
        let maxPrice = document.getElementById('maxPrice');
        let price = [minPrice, maxPrice];

        priceRange[0].noUiSlider.on('update', function (values, handle) {
            price[handle].value = values[handle];
        });

        priceRange[0].noUiSlider.on('end', function (values, handle) {
            priceRange.closest('form').submit();
        });

        minPrice.addEventListener('change', function () {
            let value = this.value.replace(',', '.');
            if (useDecimal) {
                value = parseFloat(value).toFixed(2);
            }

            priceRange[0].noUiSlider.set([value, null], true, true);
            priceRange.closest('form').submit();
        });

        maxPrice.addEventListener('change', function () {
            let value = this.value.replace(',', '.');
            if (useDecimal) {
                value = parseFloat(value).toFixed(2);
            }

            priceRange[0].noUiSlider.set([null, value], true, true);
            priceRange.closest('form').submit();
        });
    }

    /* Age range */
    let ageRange = $('#ageRange');
    if (ageRange.length) {
        noUiSlider.create(ageRange[0], {
            start: [ageRange.data('start'), ageRange.data('end')],
            connect: true,
            step: 1,
            range: {
                'min': ageRange.data('min'),
                'max': ageRange.data('max')
            },
            format: {
                to: function(value) {
                    return Math.round(value);
                },
                from: function (value) {
                    return Math.round(value);
                }
            }
        });

        let minAge = document.getElementById('minAge');
        let maxAge = document.getElementById('maxAge');
        let ages = [minAge, maxAge];

        ageRange[0].noUiSlider.on('update', function (values, handle) {
            ages[handle].value = values[handle];
        });

        ageRange[0].noUiSlider.on('end', function (values, handle) {
            ageRange.closest('form').submit();
        });

        minAge.addEventListener('change', function () {
            ageRange[0].noUiSlider.set([this.value, null]);
            ageRange.closest('form').submit();
        });

        maxAge.addEventListener('change', function () {
            ageRange[0].noUiSlider.set([null, this.value]);
            ageRange.closest('form').submit();
        });
    }

});
